import React from "react";
import enter from "../../../assets/svg/chat-bot/enter-msg.svg";
import mawalogLogo from "../../../assets/svg/mawalog.svg";

const ChatInput = ({
  inputField,
  handleChange,
  handleSubmitQuestion,
  startCamera,
  fileInputRef,
  handleImageUpload,
  stagedImage,
  clearStagedImage,
}) => {
  return (
    <div className="d-flex flex-column" style={{ gap: "12px" }}>
      <div
        style={{
          position: "relative",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div
          className="relative w-full"
          style={{ maxWidth: "900px", margin: "0 auto" }}
        >
          <div 
            style={{
              borderRadius: "14px",
              backgroundColor: "#fdfdfdff",
              border: "1px solid #0A22401A",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              marginBottom: "8px",
            }}
          >
            {stagedImage && (
              <div
                style={{
                  position: "relative",
                  width: "80px",
                  height: "80px",
                  margin: "16px 16px 0 16px",
                  flexShrink: 0,
                }}
              >
                <img
                  src={stagedImage}
                  alt="Staged"
                  style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "12px" }}
                />
                <button
                  type="button"
                  onClick={clearStagedImage}
                  style={{
                    position: "absolute",
                    top: "-8px",
                    right: "-8px",
                    background: "rgba(0,0,0,0.6)",
                    color: "white",
                    border: "none",
                    borderRadius: "50%",
                    width: "24px",
                    height: "24px",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    padding: 0,
                    lineHeight: 1,
                  }}
                >
                  &times;
                </button>
              </div>
            )}
            
            <div style={{ position: "relative", width: "100%" }}>
              <input
                placeholder="Enter your message"
                type="text"
                className="w-full py-3"
                style={{
                  paddingLeft: "16px",
                  paddingRight: "90px",
                  backgroundColor: "transparent",
                  border: "none",
                  outline: "none",
                }}
                value={inputField}
                onChange={handleChange}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSubmitQuestion();
                  }
                }}
              />
          {/* <button
            onClick={startCamera}
            className="absolute right-14 top-7 -translate-y-1/2 cursor-pointer"
            style={{
              width: "34px",
              height: "34px",
              borderRadius: "50%",
              background:
                "linear-gradient(135deg, #0066CC 0%, #007bff 70%, #007bff 70%)",
              border: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              padding: 0,
              lineHeight: 0,
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
              <circle cx="12" cy="13" r="4" />
            </svg>
          </button> */}
              <button
                type="button"
                onClick={() => fileInputRef.current.click()}
                className="absolute right-12 top-1/2 -translate-y-1/2 cursor-pointer"
                style={{
                  background: "none",
                  border: "none",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "8px",
                }}
                title="Upload Image"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#8790A1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path>
                </svg>
              </button>

              <img
                src={enter}
                onClick={handleSubmitQuestion}
                className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer"
                width="34"
                height="34"
                alt="send"
              />
            </div>
          </div>
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            onChange={handleImageUpload}
            style={{ display: "none" }}
          />
        </div>
      </div>
      <div className="text-xs justify-center text-[#8790A1] flex font-omny gap-1 mb-3">
        Powered by{" "}
        <span className="text-sm justify-center text-[#8790A1] flex font-omny gap-2">
          <img
            src={mawalogLogo}
            alt="logo"
            className="cursor-pointer"
            onClick={() => window.open("https://mawalog.com/", "_blank")}
          ></img>
        </span>
      </div>
    </div>
  );
};

export default ChatInput;
